import React, { useState } from "react";
import { InfoTip } from "@/components/InfoTip";
import { Building2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useBilling } from "@/contexts/BillingContext";
import { useL } from "@/lib/useL";

// Teacher enters the code given by their school to receive credits from the school pool.
export function RedeemOrgCode() {
  const L = useL();
  const { refresh } = useBilling();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/billing/redeem-code", { code: code.trim() });
      toast.success(L(`${data.credits} crédits ajoutés grâce à ${data.org_name}.`, `${data.credits} credits added from ${data.org_name}.`));
      setCode("");
      refresh();
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast(typeof d === "string" ? d : L("Code invalide.", "Invalid code."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="border border-border p-4 mt-6" data-testid="redeem-org-code">
      <div className="sux-marker mb-2 flex items-center gap-2">
        <Building2 className="w-3 h-3" /> {L("Code établissement", "School code")}
        <InfoTip testid="redeem-org-code-info" content={L("Si votre école a acheté des crédits pour ses enseignants, elle vous donne un code. Saisissez-le une fois : vos crédits arrivent tout de suite sur votre compte.", "If your school bought credits for its teachers, it gives you a code. Enter it once: your credits arrive on your account right away.")} />
      </div>
      <p className="text-xs text-muted-foreground mb-3">{L("Votre établissement vous a donné un code ? Saisissez-le pour recevoir vos crédits.", "Did your school give you a code? Enter it to receive your credits.")}</p>
      <div className="flex gap-2">
        <input
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder={L("EX. JMOULIN-7K2F", "E.G. JMOULIN-7K2F")}
          required
          minLength={4}
          className="flex-1 border border-border px-3 py-2 font-mono text-sm bg-background focus:outline-none focus:border-[#002FA7]"
          data-testid="redeem-org-code-input"
        />
        <button type="submit" disabled={busy} data-testid="redeem-org-code-submit"
          className="font-mono uppercase tracking-[0.2em] text-[11px] bg-[#002FA7] text-white px-4 hover:bg-[#00227A] transition-colors disabled:opacity-50">
          {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : L("Valider", "Apply")}
        </button>
      </div>
    </form>
  );
}

export default RedeemOrgCode;
